import { t } from "@/i18n-js/instance";
import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import { ConfirmationModal } from "@circle-react-shared/ModalsV2/ConfirmationModal";
import { SanitizeHTMLString } from "../../../uikit/SanitizeContent";

interface WithdrawConnectionConfirmModalProps {
  disabled?: boolean;
  onCancel: () => void;
  onConfirm: () => void | Promise<void>;
  recipient: string;
}

const i18nBase = "member_directory.cancel_request_modal";

export const WithdrawConnectionConfirmModalContent = ({
  onConfirm,
  onCancel,
  disabled = false,
  recipient,
}: WithdrawConnectionConfirmModalProps) => {
  const modal = useModal();
  return (
    <ConfirmationModal
      isOpen={modal.visible}
      onClose={modal.hide}
      confirmVariant="circle"
      confirmText={t(`${i18nBase}.confirm_text`)}
      title={t(`${i18nBase}.title`)}
      cancelText={t(`${i18nBase}.cancel_text`)}
      onConfirm={onConfirm}
      onCancel={onCancel}
      disabled={disabled}
    >
      <SanitizeHTMLString
        content={t(`${i18nBase}.body`, { connection_target: recipient })}
        className="text-default text-base leading-6 tracking-tighter"
      />
    </ConfirmationModal>
  );
};

interface WithdrawConnectionConfirmModalProps {
  disabled?: boolean;
  onCancel: () => void;
  onConfirm: () => void | Promise<void>;
  recipient: string;
}
export const WithdrawConnectionConfirmModal =
  ModalManager.create<WithdrawConnectionConfirmModalProps>(
    ({ onConfirm, onCancel, disabled = false, recipient }) => (
      <WithdrawConnectionConfirmModalContent
        onConfirm={onConfirm}
        onCancel={onCancel}
        disabled={disabled}
        recipient={recipient}
      />
    ),
  );

export const useWithdrawConnectionConfirmModal = () =>
  useModal(WithdrawConnectionConfirmModal);
